import React, { useState } from 'react';

import {
    makeStyles,
    Box,
    Typography,
    Tabs,
    Tab,
    isWidthUp,
    withWidth,
    WithWidth,
    fade
} from '@material-ui/core';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import {
    IconNovedad,
    Link,
    HomeWidgetVacio,
    getCiaFromUrl
} from '@portal/arq-portal-core';

import Banner from './Banner';
import Banner2 from './Banner2';
import Resumen from './Resumen';
import Resumen2 from './Resumen2';
import { updateUrlParameter } from './helper';
import Marca2 from './Marca2';
import Marca from './Marca';

function TabPanel(props: any) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component={'span'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    carousel: {
        height: '160px',
        maxWidth: '100%',
        width: '100vw',
        '@media screen and (max-width: 767px)': {
            height: '160px',
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
        '& .carousel': {
            overflow: "visible"
        },
        '& .control-dots': {
            bottom: "-30px",
            marginLeft: '-13px',
            marginBottom: '-6px',
            marginTop: '0px !important',
            paddingTop: '2px',
            borderTop: '1px solid #d6d8d8',
            '& .dot': {
                opacity: '1',
                backgroundColor: "#606060",
                boxShadow: "none",
                height: "10px",
                width: "10px",
                '&:hover':{
                    backgroundColor: "#c8c8c8 !important",
                    '&:active':{
                        backgroundColor: theme.palette.primary.main + "!important"
                    }
                },
                '&.selected': {
                    backgroundColor: theme.palette.primary.main
                }
            },
        },
        '& .control-prev':{
            width: '28px'
        },
        '& .control-next':{
            width: '28px'
        },
        '& .control-next.control-arrow:before': {
            fontFamily: 'GCO-icons',
            content: '"\\e92a"',
            color: "#606060",
            border: "none !important",
            margin: '0px 0px 0px -4.5px'
        },
        '& .control-prev.control-arrow:before': {
            fontFamily: 'GCO-icons',
            content: '"\\e92b"',
            color: "#606060",
            border: "none !important",
            margin: '0px 0px 0px -4.5px'
        },
        '& .control-next:hover.control-arrow::before': {
            color: "#DC0028 !important"
        },
        '& .control-prev:hover.control-arrow::before': {
            color: "#DC0028 !important"
        }

    },
    soloDesktop: {
        '@media screen and (max-width: 767px)': {
            display: 'none'
        }
    },
    soloMobile: {
        display: 'none',
        '@media screen and (max-width: 767px)': {
            display: 'block'
        }
    },
    default_tab: {
        color: '#000000',
        textTransform: 'none',
        fontSize: 15
    },
    active_tab: {
        textTransform: 'none',
        color: theme.palette.primary.main,
        '& .MuiTab-wrapper': {
            fontWeight: 'bold',
            '&>div': {
                color: '#DC0028 !important',
            }
        }
    },
    exclamation: {
        height: "16px",
        color: theme.palette.primary.main
    },
    detailTitle: {
        fontWeight: 900,
        textDecoration: 'underline',
        textUnderlineOffset: '5px',
        textDecorationThickness: '2px'
    },
    tabRoot: {
        maxHeight: '220px',
        '@media screen and (max-width: 767px)': {
            width:"100%",
            float: "left",
        },
        '& .MuiBox-root': {
            padding: '0px',
        },
    },
    image1: {
        width: "100vw",
        maxWidth: "100%",
        height: "240px",
        objectFit: "cover",
        backgroundColor: fade(theme.palette.secondary.main, 0.5)
    },
    image1text: { margin: '10px', position: 'absolute', bottom: '60px', left: '20px' },
    verMas: {
        color: theme.palette.primary.main,
        fontWeight: "bold",
        borderBottom: "1px solid " + theme.palette.primary.main,
        fontSize: "12px",
        margin: "auto 0",
        marginLeft: "20px",
        '&:hover': {
            color: '#b7788f',
            borderBottom: '1px solid #b7788f',
        },
    },
    tabsContainer: {
        opacity: '1',
        marginBottom: '10px',
        borderBottom: "1px solid #919191",
        
        '@media screen and (max-width: 767px)': {
            width:"100%",
            float: "left",
        },

        '& .MuiTabs-scrollButtonsDesktop': {
            '@media screen and (max-width: 767px)': {
              display: "inline-flex",
            },
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
        '& .MuiTabs-indicator': {
            bottom: '8px !important',
        }
    },
    novedad:{
        marginBottom: '-7px', 
        marginRight: '-7px', 
        color: '#DC0028',
    },
    titleTab: {
        '&:hover': {
            color: '#919191',
        },
        '&:active': {
            color: '#DC0028',
        },
        '&:focus': {
            color: '#DC0028',
        },
    },
    startPause:{
        marginTop: '39.5px !important',
        display: "flex",
        justifyContent: "center",
        width:'100%',
        '@media screen and (max-width: 767px)': {
            width:"100%",
        }
    },
    nobuttons:{
        marginTop: '29px !important',
        borderTop: '1px solid #d6d8d8',
        paddingTop: '10px'
    },
    play:{
        zIndex: 1,
        cursor: 'pointer',
        width: 0,
        height: 0,
        borderTop: '5px solid transparent',
        borderLeft: '10px solid #606060',
        borderBottom: '5px solid transparent',
        '&:hover': {
            borderTop: '5px solid transparent',
            borderLeft: '10px solid #c8c8c8',
            borderBottom: '5px solid transparent',
            '&:active':{
                borderTop: '5px solid transparent',
                borderLeft:'10px solid' + theme.palette.primary.main + "!important",
                borderBottom: '5px solid transparent',
            },
        },
    },
    pause:{
        zIndex: 1,
        cursor: 'pointer',
        height:'10.1px',
        width: '2px',
        borderLeft:'3.5px solid #606060',
        borderRight:'3.5px solid #606060',  
        background:'transparent',
        '&:hover': {
            borderLeft: '3.5px solid #c8c8c8',
            borderRight:'3.5px solid #c8c8c8',
            '&:active':{
                borderLeft:'3.5px solid' + theme.palette.primary.main + "!important",
                borderRight:'3.5px solid' + theme.palette.primary.main + "!important",
            }
        },
        
    },
    hide:{
        display:'none'
    }
}));
function ciaMatchSharePointName(cia: string ){
    switch(cia){
        case 'SBI': 
            return 'SB';
        case 'SPU':
            return 'PU';
    }
    return cia;
}
export const MeInteresaTabs = withWidth()((props: any & WithWidth) => {
    const classes = useStyles(props);
    const [value, setValue] = useState(1);
    const [play, setPlay] = useState(true);
    const [carouselInterval, setCarouselInterval] = useState<number>(6000);
    const cia = ciaMatchSharePointName(getCiaFromUrl())
    // @ts-ignore
    const handleChange = ((event: any, newValue: number) => {
        setValue(newValue);
    });

    const chunkArrayInGroups = (arr: any, size: number) => {
        var myArray = [];
        for (var i = 0; i < arr.length; i += size) {
            myArray.push(arr.slice(i, i + size));
        }
        return myArray;
    }

    var bannerdobledefault = 'assets/bannerdoble.png';
    var bannersimpledefault = 'assets/bannersimple.png';

    switch(cia){
        case 'SBI': 
        case 'SB': 
            bannerdobledefault = 'assets/bannerdoble_SB.png';
            bannersimpledefault = 'assets/bannersimple_SB.png';
            break;
        case 'SPU':
        case 'PU':
            bannerdobledefault = 'assets/bannerdoble_PU.png';
            bannersimpledefault = 'assets/bannersimple_PU.png';
            break;
        case 'NH':
            bannerdobledefault = 'assets/bannerdoble_NH.png';
            bannersimpledefault = 'assets/bannersimple_NH.png';
            break;
        case 'PRE':
            bannerdobledefault = 'assets/bannerdoble_PRS.png';
            bannersimpledefault = 'assets/bannersimple_PRS.png';
            break;
        case 'AIE':
            bannerdobledefault = 'assets/bannerdoble_AIE.png';
            bannersimpledefault = 'assets/bannersimple_AIE.png';
            break;        
        case 'OCC':
            bannerdobledefault = 'assets/bannerdoble_OCC.png';
            bannersimpledefault = 'assets/bannersimple_OCC.png';
            break;
        default:
            bannerdobledefault = 'assets/bannerdoble.png';
            bannersimpledefault = 'assets/bannersimple.png';
            break;
    }

    return (
        <React.Fragment>
            <Tabs className={classes.tabsContainer} variant="scrollable" scrollButtons="auto" value={value} onChange={handleChange} TabIndicatorProps={{ style: { background: props.data? '#dc0028': 'inherit', marginTop: "0px" } }}>
                <div style={{ alignSelf: 'center' }}/>

                {props.data?.map((cat: any, indx: number) =>
                    <Tab
                        key={"tab_" + indx}
                        label={
                            <div style={{ display: 'flex' }} className={classes.titleTab} >{cat.Titulo} {cat.Novedad &&
                                <IconNovedad className={classes.novedad} />}
                            </div>} style={{ textTransform: 'none', minWidth: 0, padding: "0px 10px" }} classes={{ selected: classes.active_tab }} {...a11yProps(indx)} />
                )}
                {<div style={{ flex: '1 1 0' }}/>}
                {props.vermas &&
                    <Link to={updateUrlParameter(updateUrlParameter(props.vermas,"cia",cia), "Categoria",props.data? props.data[value - 1].Titulo: "")} className={classes.verMas}>Ver más</Link>
                }

            </Tabs>
            {props.data?.map((cat: any, indx: number) => {
                if (cat.ListaNoticias !== null && cat.ListaNoticias.length > 0) {
                    var noticiasPagina = 2;
                    var componentes;
                    let nBotones;
                    if (cat.Visualizacion === "BannerDoble") {
                        nBotones = cat.ListaNoticias.length;
                        componentes = cat.ListaNoticias.map((pub: any, jndx: number) =>
                            <Banner key={"pub_" + jndx} publicacion={pub} defaultImage={<img src={bannerdobledefault} alt='Imagen de carga'></img>}></Banner>
                        );
                        noticiasPagina = 1;
                    } else if (cat.Visualizacion === "BannerSimple") {
                        nBotones = chunkArrayInGroups(cat.ListaNoticias, 2).length;
                        componentes = chunkArrayInGroups(cat.ListaNoticias, 2).map((pubs, jndx) => {
                            return <Banner2 key={"pub_" + jndx} pub1={pubs[0]} pub2={pubs[1]}></Banner2>
                        }
                        );
                    } else if (cat.Visualizacion === "Marca") {
                        nBotones = isWidthUp('lg', props.width) ? chunkArrayInGroups(cat.ListaNoticias, 2).length : cat.ListaNoticias.length;
                        componentes = isWidthUp('lg', props.width) ? chunkArrayInGroups(cat.ListaNoticias, 2).map((pubs, jndx) =>
                            <Marca2 key={"pub_" + jndx} pub1={pubs[0]} pub2={pubs[1]} />
                        ) : cat.ListaNoticias.map((pub: any, jndx: number) =>
                            <Marca key={"pub_" + jndx} publicacion={pub} defaultImage={<img src={bannersimpledefault} alt='Imagen de carga'></img>} />
                        )
                    } 
                    else {
                        nBotones = isWidthUp('lg', props.width) ? chunkArrayInGroups(cat.ListaNoticias, 2).length : cat.ListaNoticias.length;
                        componentes = isWidthUp('lg', props.width) ? chunkArrayInGroups(cat.ListaNoticias, 2).map((pubs, jndx) =>
                            <Resumen2 key={"pub_" + jndx} pub1={pubs[0]} pub2={pubs[1]} />
                        ) : cat.ListaNoticias.map((pub: any, jndx: number) =>
                            <Resumen key={"pub_" + jndx} publicacion={pub} defaultImage={<img src={bannersimpledefault} alt='Imagen de carga'></img>} />
                        )
                    }
                    const carouselProps = {
                        showThumbs: false,
                        showStatus: false,
                        animationHandler: 'fade',
                        infiniteLoop: true,
                        showIndicators: cat.ListaNoticias.length > noticiasPagina
                    };
                    return <TabPanel key={"pnl_" + indx} value={value - 1} index={indx} className={classes.tabRoot}>
                        <div className="meInteresaCarousel" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' , flexDirection:'column'}}>
                            <Carousel className={classes.carousel}  autoPlay={play}  interval={carouselInterval} {...carouselProps}>
                                {componentes}
                            </Carousel>
                            { nBotones >= 2 && cat.ListaNoticias.length > noticiasPagina && 
                            <div className={classes.startPause} style={{marginLeft: (26 * nBotones)+ 'px' }}> {!play? 
                                <div title={"Reproducir"} className={classes.play} onClick={()=>{
                                      setCarouselInterval(300);
                                      setTimeout(() => {
                                        setCarouselInterval(6000);
                                      }, 300)
                                    setPlay(!play)}}/> :
                                <div title={"Pausar"} className={classes.pause } onClick={()=>setPlay(!play)}/>}
                            </div>}
                        </div>
                    </TabPanel>
                } else {
                    return <TabPanel key={"pnl_" + indx} value={value - 1} index={indx} className={classes.tabRoot}>
                        <HomeWidgetVacio mensaje="No hay contenido destacado" />
                    </TabPanel>
                }
            })}
      
        </React.Fragment>
    )
})